// Backend storage helpers for Hercules site (saves to PHP backend)
// Auto-detect domain for production, fallback to localhost for development
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ||
  (window.location.hostname === 'localhost' ? "http://localhost:8000" : "");

export const defaultPremium = {
  "Neon/LED": { value: 85, label: "Ágil" },
  "Corte a laser": { value: 96, label: "Turbo" },
  "UV Print": { value: 94, label: "Turbo" },
  "Projeto 3D": { value: 92, label: "Turbo" },
  Envelopamento: { value: 70, label: "Rápido" },
};

export const defaultThemeColors = {
  hero: "#0b1b34",
  services: "#10233f",
  destaques: "#0f2545",
  faq: "#0b1b34",
  contato: "#facc15",
};

export async function getSettings() {
  try {
    // For production, use relative URLs (same domain)
    const apiUrl = window.location.hostname === 'localhost'
      ? `${BACKEND_URL}/api/config/load.php`
      : '/backend-php/api/config/load.php';

    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to load settings from backend, using defaults:", error);
    return {
      contact: {
        whatsapp: "https://wa.me/0000000000",
        instagram: "https://instagram.com/hercules_placeholder",
      },
      stats: {
        entregues: "+1.500",
        anos: "12",
        clientes: "+300",
      },
      premium: defaultPremium,
      themeColors: defaultThemeColors,
      services: [], // seeded later from mock if empty
    };
  }
}

export async function saveSettings(settings) {
  try {
    // For production, use relative URLs (same domain)
    const apiUrl = window.location.hostname === 'localhost'
      ? `${BACKEND_URL}/api/config/save.php`
      : '/backend-php/api/config/save.php';

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log("Settings saved to backend:", result);
    return result;
  } catch (error) {
    console.error("Failed to save settings to backend:", error);
    throw error;
  }
}

export function resetSettings() {
  // This would need a reset endpoint in the backend
  console.warn("Reset functionality not implemented in backend yet");
}
